/*
 * @Author: dengxy 1148926496@qq.com
 * @Date: 2024-12-20 11:08:12
 * @LastEditors: dengxy 1148926496@qq.com
 * @LastEditTime: 2025-01-22 14:27:34
 * @FilePath: \frontend\src\main.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { createApp } from 'vue'
import dataTool from '@/utils/localStorage'
import dictTool from '@/utils/dict'
import locale from './locales'
import '@/assets/styles/index.scss' // global css


import App from './App'
import store from './store'
import router from './router'
import directive from './directive' // directive

// 注册指令
import plugins from './plugins' // plugins
import { download, downloadFileByUrl } from '@/utils/request'

// svg图标
import 'virtual:svg-icons-register'
import elementIcons from '@/components/SvgIcon/svgicon'
import './permission' // permission control
import { parseTime, resetForm, addDateRange, handleTree, selectDictLabel, selectDictLabels } from '@/utils/ruoyi'


const app = createApp(App)
// 全局方法挂载
app.config.globalProperties.$dataTool = dataTool
app.config.globalProperties.$dictTool = dictTool
app.config.globalProperties.download = download
app.config.globalProperties.downloadFileByUrl = downloadFileByUrl
app.config.globalProperties.parseTime = parseTime
app.config.globalProperties.resetForm = resetForm
app.config.globalProperties.handleTree = handleTree
app.config.globalProperties.addDateRange = addDateRange
app.config.globalProperties.selectDictLabel = selectDictLabel
app.config.globalProperties.selectDictLabels = selectDictLabels

app.use(router)
app.use(store)
app.use(plugins)
app.use(elementIcons)
app.use(locale)
directive(app)

app.mount('#app')
